import React, { FC, useCallback, useMemo } from 'react';

import { Orderlist } from '../../../models/OrderList';
import { ListManager } from '../components/ListManager';
import { ButtonSize, ButtonTheme } from './Button';

type Props = {
    readonly size?: ButtonSize;
    readonly theme?: ButtonTheme;
    readonly label?: string;
    readonly iconCode?: string;
    readonly className?: string;
    readonly hideListId?: string;
    readonly lists?: ReadonlyArray<Orderlist>;
    readonly onListClick?: (list: Orderlist) => Promise<void> | void;
    readonly onCreateNewListClicked?: (newListName: string) => void;
    readonly disabled: boolean;
};

export const SelectionListDropDown: FC<Props> = ({
    size,
    theme,
    label,
    iconCode,
    hideListId,
    lists,
    onListClick = () => {},
    onCreateNewListClicked,
    disabled
}) => {
    const finalLists = useMemo(() => lists?.filter(list => list.id !== hideListId), [hideListId, lists]);

    const createNewSelectionList = useCallback(
        (newSelectionName: string) => {
            if (!newSelectionName) {
                return;
            }
            onCreateNewListClicked?.(newSelectionName);
        },
        [onCreateNewListClicked]
    );

    const handleListClick = useCallback(
        async (listId: string) => {
            const orderlist = finalLists?.find(list => list.id === listId);
            if (orderlist) {
                await onListClick(orderlist);
            }
        },
        [finalLists, onListClick]
    );

    return (
        <ListManager
            size={size}
            theme={theme}
            icon={iconCode}
            label={label}
            options={finalLists}
            onSelect={handleListClick}
            onCreate={createNewSelectionList}
            disabled={disabled}
        />
    );
};
